















import { Component, Vue } from 'vue-property-decorator'
import Player from '@/components/Player/index.vue'

@Component({
  components: {
    Player
  }
})

export default class Wizard extends Vue {
  // __COMPUTED
  private get playback (): any {
    const n: string = 'http://distribution.bbb3d.renderfarming.net/video/mp4/bbb_sunflower_1080p_30fps_normal.mp4'
    const { query }: any = this.$route

    return (query.i && decodeURIComponent(query.i).match('rtsp://'))
      ? decodeURIComponent(query.i)
      : n
  }
}
